import { HTMLAttributes } from 'react';
import { FilterChipContainer, IconContainer, Label } from './atoms';
import { CloseIcon, Icon, IconName, IconSize } from '@ardoq/icons';
import { ButtonSize, GhostButton } from '@ardoq/button';
import { type I18nLocale, t } from '@ardoq/i18n';

type FilterChipProps = {
  iconName?: IconName;
  isDisabled?: boolean;
  onClose: VoidFunction;
  popoverText?: string;
  label: string;
  role?: 'listitem';
  i18nLocale: I18nLocale;
} & Omit<HTMLAttributes<HTMLDivElement>, 'onClick'>;

export const FilterChip = ({
  iconName,
  children,
  onClose,
  isDisabled,
  role,
  label,
  i18nLocale,
}: FilterChipProps) => (
  <FilterChipContainer
    $isDisabled={isDisabled}
    $isActive={!isDisabled}
    aria-disabled={isDisabled}
    role={role}
  >
    {iconName && (
      <IconContainer>
        <Icon iconName={iconName} iconSize={IconSize.SMALL} />
      </IconContainer>
    )}
    <Label>{children}</Label>
    {!isDisabled && (
      <GhostButton // using GhostButton instead of IconButton to have less-precise tooltip text to accessible label
        aria-label={t(
          i18nLocale,
          'statusUi:filterChip.removeFilterAriaLabel',
          { label },
          'Remove filter {{label}}'
        )}
        onClick={onClose}
        data-tooltip-text={t(
          i18nLocale,
          'statusUi:filterChip.removeFilter',
          'Remove filter'
        )}
        buttonSize={ButtonSize.SMALL}
        style={{ minHeight: '26px' }}
      >
        <CloseIcon iconSize={IconSize.SMALL} />
      </GhostButton>
    )}
  </FilterChipContainer>
);
